import gql from 'graphql-tag';

export const pinSectionContent = gql(`
  mutation pinSectionContent($sectionId: UUID!, $contentId: UUID!) {
    pinSectionContent(sectionId: $sectionId, contentId: $contentId)
  }
`);
